<script>
import { PhxIcon } from '@phx-styleguides/pia';
import PictureLazy from '@maison/components/common/PictureLazy.vue';

export default {
  components: {
    PictureLazy,
    PhxIcon,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
    },
    category: {
      type: String,
      default: '',
    },
    categoryLink: {
      type: String,
      default: '',
    },
    rokkaImg: {
      type: Object,
      default: null,
    },
    dataTracking: {
      type: Object,
      default: null,
    },
  },
};
</script>

<template>
  <div class="article">
    <div class="picture picture--block" style="background-color: #f8f8f8">
      <picture-lazy v-bind="rokkaImg" />
    </div>

    <div class="article__text-wrapper">
      <h3 class="h5">{{ title }}</h3>
      <div>{{ description }}</div>
      <div>
        <a
          class="btn btn--no-padding expand-target"
          :href="link"
          :data-tracking="dataTracking ? JSON.stringify(dataTracking) : null"
          :aria-label="title"
        >
          {{ $t('Search.article.discoverTheStory') }}
          <div class="btn__icon btn__icon--end">
            <phx-icon icon="go" class="icon--2xs" bidirectional />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>
